import qs from 'qs';
import axios from 'axios';

export default {
  createDevice: ({commit}, payload) => {
    axios({
      url: '/engine/devices',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('ADD_DEVICE', response.data);
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  modifyDevice: ({commit}, payload) => {
    axios({
      url: '/engine/devices/' + payload['id'],
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('MODIFY_DEVICE', response.data);
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addDeviceTopic: ({commit}, payload) => {
    axios({
      url: '/engine/devices/' + payload['id'] + '/topics',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        const topicData = {
          ...response.data,
          deviceId: payload['id']
        };
        commit('ADD_DEVICE_TOPIC', topicData);
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  deleteDeviceTopic: ({commit}, payload) => {
    axios({
      url: '/engine/devices/' + payload['id'] + '/topics/' + payload['deviceTopicId'],
      method: 'DELETE'
    })
      .then(() => {
        commit('DELETE_DEVICE_TOPIC', {id: payload['id'], deviceTopicId: payload['deviceTopicId']});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addDeviceEndpoint: ({commit}, payload) => {
    axios({
      url: '/engine/devices/' + payload.id + '/endpoints',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then(response => {
        commit('devices/MODIFY_DEVICE', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  deleteDeviceEndpoint: ({commit}, payload) => {
    axios({
      url: '/engine/devices/' + payload.deviceId + '/endpoints/' + payload.id,
      method: 'DELETE'
    })
      .then(response => {
        commit('devices/MODIFY_DEVICE', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  copyDeviceTopics: ({commit}, payload) => {
    axios({
      url: '/engine/devices/' + payload['id'] + '/copytopics',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        response.data.forEach(item => {
          commit('ADD_DEVICE_TOPIC', {
            ...item,
            deviceId: item.device_id
          });
        });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  }
};